import {z} from '@hono/zod-openapi';

const NUL = '\u0000';

/**
 * `customerId` is interpolated into the list query's raw SQL parameters, and Postgres stores and
 * compares no NUL in a `text` column — it rejects the statement, which used to travel as a
 * `REPOSITORY_ERROR` 500 plus a Sentry event from an api-key-gated operation. The gate turns that
 * into the 400 the route already declares. A `refine` rather than `.regex()`, so nothing about it
 * is published into the generated document.
 */
const carriesNoNulByte = (value: string) => !value.includes(NUL);

/** `GET /pricereports`: an optional tenant-customer filter. */
export const priceReportListQuerySchema = z.object({
  customerId: z
    .string()
    .refine(carriesNoNulByte, 'customerId must not carry a NUL character')
    .optional(),
});
